module.exports = __webpack_public_path__ + "static/media/photography02.0047dbdc.png";